import {
  CreateCategoriesRequest,
  MetafieldSelectedsOrErrorListV2Type,
  MetafieldSelectedsOrErrorType,
  MetafieldSelectedV2Dto,
  ProductDetailsResponseDto,
  ProductImageRequestDto,
  TagRequest,
} from '@tiendanube/common';
import { UpdateImagesRequest } from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/ImagesRequest';
import { UpsertMetafieldsRequest } from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/MetafieldsRequest';

export function getTags(tags: string | undefined): TagRequest[] {
  if (!tags) return [];
  return tags.split(',').map((tag) => ({
    tag: tag.trim(),
  }));
}

export function getCategories(
  categories: string[] | undefined,
): CreateCategoriesRequest[] {
  if (!categories) return [];
  return categories.map((category, index) => ({
    id: Number(category),
    order: index,
  }));
}

export function getImages(
  images: ProductImageRequestDto[],
): UpdateImagesRequest[] {
  if (!images.length) return [];
  return images.map((image, index) => ({
    id: Number(image.image_id),
    order: index,
  }));
}

export function getMetafields(
  metafields: MetafieldSelectedsOrErrorListV2Type | undefined,
): { metafields: UpsertMetafieldsRequest[] } | undefined {
  if (
    !metafields ||
    metafields.fromApi === 'error' ||
    metafields.internals === 'error'
  )
    return undefined;

  const metafieldsToUpsert: UpsertMetafieldsRequest[] = [];
  const allMetafields: MetafieldSelectedV2Dto[] = [
    ...metafields.fromApi,
    ...metafields.internals,
  ];

  allMetafields.forEach((metafield) => {
    if (metafield.value) {
      metafieldsToUpsert.push({
        uuid: metafield.id,
        value: metafield.value,
      });
    }
  });
  return { metafields: metafieldsToUpsert };
}

export function getVariantMetafields(
  metafields:
    | MetafieldSelectedsOrErrorListV2Type
    | MetafieldSelectedsOrErrorType
    | undefined,
): { metafields: UpsertMetafieldsRequest[] } | undefined {
  if (!metafields || metafields === 'error') {
    return undefined;
  }

  if ('fromApi' in metafields && 'internals' in metafields) {
    return getMetafields(metafields);
  } else {
    return {
      metafields: metafields.map((metafield) => ({
        uuid: metafield.id,
        value: metafield.selected,
      })),
    };
  }
}

export function createResponseDto(
  createdId: number,
): ProductDetailsResponseDto {
  return { id: createdId } as unknown as ProductDetailsResponseDto;
}
